import * as TYPES from './types';

export default {
    [TYPES.SET_GEOGRAPHIC](payload = {}) {
        this.geoGraphic = payload
    },
    [TYPES.SET_COUNTRYCONFIG](payload = {}) {
        this.countryConfig = payload
    },

    [TYPES.GET_GEOGRAPHIC]({ type, hjId, locType, locStr }) {
        const url =
            type === 'city'
                ? '/api-site/geographic/city/' + hjId
                : '/api-site/geographic/nbr/' + hjId;
        return this.axiosIns.get(url, { params: { locType, locStr } }).then(res => {
            this[TYPES.SET_GEOGRAPHIC](res.data);
        })
    },
    [TYPES.GET_COUNTRYCONFIG](siteId) {
        return this.axiosIns.get('/api-site/hjNbrConfig/country', {
            params: { siteId }
        }).then(res => {
            this[TYPES.SET_COUNTRYCONFIG](res?.data || 'usa');
        });
    }
}